<template>
    <div>
        <h2>Pädagogik-Telefonat</h2>
        <p>
            Bitte gib einen Termine an, wann du das Pädagogik-Gespräch mit unserer Partnerin Simone Liebegut
            wahrnehmen kannst.
            <br/>
            Du erhältst selbstverständlich eine Benachrichtigung, sobald Sie einen der Vorschläge annimmt.
        </p>
        <form ref="form" method="post" :action="effectiveAction" @submit.prevent.once="submit">
            <input type="hidden" :value="learningUnitId" name="learning_unit_id">
            <input type="hidden" :value="appointmentId" name="appointment_id">

            <date-editor :max-dates="maxDates" :dates="dateSelections"></date-editor>

            <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="comment">Kommentar</label>
                </div>
                <input id="comment" name="comment" class="form-control" />
            </div>

            <slot>
                <csrf></csrf>
            </slot>

            <button type="submit" class="btn btn-success mt-3">Absenden</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'talk-appointment',
    props: {
        'action': String,
        'appointmentId': Number,
        'learningUnitId': Number,
        'maxDates': {
            type: Number,
            default: 1
        },
        'dates': {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            'dateSelections': this.dates,
        }
    },
    computed: {
        effectiveAction: function () {
            return this.action || '/talk_appointment/saveAppointment'
        },
    },
    methods: {
        submit: function (e) {
            this.$refs.form.submit();
        }
    }
}
</script>

<style scoped>

</style>
